module.exports = __webpack_public_path__ + "static/media/share.54b07275.png";